import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import { VideoPlayer } from '@cotyorg/ccx-organism-video';
import {
  trackVideoPlayEvent,
  trackVideoMilestoneEvent,
} from '@cotyorg/ccx-utils/js/tracking/adobe-dtm/events/video';
import SectionHeader from '../../../../atoms/SectionHeader';

export const TipsAndTricksSection = ({ sectionHeadings, videos }) => {
  const tipsAndTricksVideosKeys = R.filter(
    (key) => R.contains('tipsAndTricksVideo', key),
    R.keysIn(videos)
  );

  return (
    tipsAndTricksVideosKeys.length > 0 && (
      <div className="tips-and-tricks-section">
        <div className="grid-container">
          <div className="grid-x grid-margin-x flex-container align-middle align-center">
            <div className="cell">
              <SectionHeader>
                <Heading extraClass="section__title" level={2}>
                  {R.path(['tipsAndTricks', 'heading'])(sectionHeadings)}
                </Heading>

                <Paragraph>
                  {R.path(['tipsAndTricks', 'introduction'])(sectionHeadings)}
                </Paragraph>
              </SectionHeader>
            </div>

            {R.map(
              (videoStoreDataKey) => (
                <div className="cell xsmall-16 large-8" key={videoStoreDataKey}>
                  <div className="video-full-width video-margin-bottom">
                    <VideoPlayer
                      videosStoreDataKey={videoStoreDataKey}
                      showControls={false}
                      config={{
                        youtube: {
                          playerVars: {
                            controls: 1,
                          },
                          embedOptions: {
                            host: 'https://www.youtube-nocookie.com',
                          },
                        },
                      }}
                      onProgress={({
                        url,
                        duration,
                        progress,
                        videoMilestone,
                      }) =>
                        trackVideoMilestoneEvent({
                          url,
                          duration,
                          progress,
                          videoMilestone,
                          title: R.path([videoStoreDataKey, 'title'], videos),
                        })
                      }
                      onPlay={({ url, duration, progress }) =>
                        trackVideoPlayEvent({
                          url,
                          duration,
                          progress,
                          title: R.path([videoStoreDataKey, 'title'], videos),
                        })
                      }
                    />
                  </div>
                </div>
              ),
              tipsAndTricksVideosKeys
            )}
          </div>
        </div>
      </div>
    )
  );
};

TipsAndTricksSection.propTypes = {
  sectionHeadings: PropTypes.instanceOf(PropTypes.object),
  videos: PropTypes.instanceOf(PropTypes.object),
};
